import { ChangeEvent, ClipboardEvent, FormEventHandler } from "react";
import React, { FC, memo, useEffect, useRef, useState } from "../../../lib/teact/teact";
import { LotScreenSettings } from "../config/uiconfig";
import { LotMessage } from "../types/types";
import '../ui/formCommon.scss'
import RangeSlider from "../../ui/RangeSlider";

import LotSelect from "../ui/lotSelect";
import store from "../store";
import { updateMienDaiCuoc } from "../redux/basicReport";
import { isCuPhapMn } from "../utils/common";
import Button from "../../ui/Button";
import SearchInput from "../../ui/SearchInput";
import { mergeAdjacentRedLinks, removeVietnameseAccents } from "../utils/searchUtils";
type OwerProps = {
    errorTextToUser?: string,
    onChangeScreen?: (screen: LotScreenSettings) => void;
    onChange?: (event: FormEventHandler<HTMLDivElement>) => void | undefined;
    onUpdate?: (html: string) => void;
    onTextChange: (html: string, rawText: string) => void;
    htmlError?: string;
    triggerTime?: string;
    onMsgTypeChange?: (type: any) => void;
    msgType: number;
    showHeader?: boolean;
    message?: LotMessage;
    maxHeight?: string;
    hidenErrorText?: boolean; // ẩn thông báo lỗi
    placeholder?: string;
    hidenFontSizeSetting?: boolean;
    showSaveButton?: boolean;
    showSearchButton?: boolean;
    onParseMessage?: () => void;
    lockBaMien?: boolean; // khóa mục chọn ba miền
}
type SearchProps = {
    onSearchConfirm: (searchText: string) => void;
    onUpClick: () => void;
    onDownClick: () => void;
    searchQuery: string;
}
const SearchBar: FC<SearchProps> = ({
    onSearchConfirm,
    onUpClick,
    onDownClick,
    searchQuery,
}) => {
    function debouce(func: Function, delay: number) {
        let timer: ReturnType<typeof setTimeout>
        return function (...args: any[]) {
            clearTimeout(timer)
            timer = setTimeout(() => func(...args), delay)

        }
    }
    function confirmSearch(query: string) {
        onSearchConfirm(query)
        console.log('search', query)
    }
    const debouceSearch = debouce(confirmSearch, 500)
    function handelChange(query: string) {
        debouceSearch(query)
    }
    return (
        <div>
            <SearchInput onChange={handelChange}
                onDownClick={() => { onDownClick() }}
                onUpClick={() => { onUpClick() }}
                value={searchQuery}
                withBackIcon hasDownButton hasUpButton />
        </div>
    )
}
const MessageEditor: FC<OwerProps> = ({
    errorTextToUser: errorText,
    onChangeScreen,
    onUpdate,
    onTextChange,
    htmlError,
    triggerTime,
    onMsgTypeChange,
    msgType,
    showHeader,
    message,
    maxHeight,
    hidenErrorText,
    placeholder,
    hidenFontSizeSetting,
    showSaveButton,
    showSearchButton,
    onParseMessage,
    lockBaMien,
}) => {
    // For some reason Safari inserts `<br>` after user removes text from input
    const SAFARI_BR = '<br>';
    let saveFontSize = localStorage["editorFontSize"]
    if (saveFontSize == undefined) {
        saveFontSize = 16
        localStorage["editorFontSize"] = saveFontSize
    }
    const currentContact = store.getState().contact.currentContact as any;
    const [fontSize, setFontSize] = useState(saveFontSize);
    const mienDaiCuocId = store.getState().basicReport.mienDaiCuocId;
    const [state, setState] = useState({
        msgType: currentContact && (currentContact!.role == 2) ? 2 : msgType,// 1 nhan, 2 chuyen
        mienDaiCuocId: lockBaMien && mienDaiCuocId == 0 ? 1 : mienDaiCuocId + "",
        showSearch: false,
        searchQuery: '',
        highlightedMarks: [] as HTMLElement[],
        currentIndex: -1,
    })
    const IGNORE_KEYS = [
        'Esc', 'Escape', 'Enter', 'PageUp', 'PageDown', 'Meta', 'Alt', 'Ctrl', 'ArrowDown', 'ArrowUp', 'Control', 'Shift',
    ];
    let inputRef: React.RefObject<HTMLDivElement> = useRef<HTMLDivElement>(null);
    let errorRef: React.RefObject<HTMLDivElement> = useRef<HTMLDivElement>(null);
    function handleChange(e: ChangeEvent<HTMLDivElement>) {
        let { innerHTML, textContent } = e.currentTarget;

        if (onUpdate)
            onUpdate(innerHTML === SAFARI_BR ? '' : innerHTML);

        // Reset focus on the input to remove any active styling when input is cleared
        // if (
        //     !IS_TOUCH_ENV
        //     && (!textContent || !textContent.length)
        //     // When emojis are not supported, innerHTML contains an emoji img tag that doesn't exist in the textContext
        //     && !(!IS_EMOJI_SUPPORTED && innerHTML.includes('emoji-small'))
        //     && !(innerHTML.includes('custom-emoji'))
        // ) 
        // {
        const selection = window.getSelection()!;
        if (selection) {
            //inputRef.current!.blur();
            //selection.removeAllRanges();
            //focusEditableElement(inputRef.current!, true);
        }
        // }
        let tmpElement = document.createElement("div")
        let tmp = innerHTML.replace(/<div>/g, '<br><div>')
        tmp = tmp.replace(/<br>/g, '\n')
        tmpElement.innerHTML = tmp
        textContent = tmpElement.innerText


        // setHtml(innerHTML)
        // setText(textContent!)
        //console.log(html)
        onTextChange(innerHTML, textContent!)
        //console.log(textContent)
    }
    const handleSliderChange = (value: number) => {
        const newSize = value;
        setFontSize(newSize);
        localStorage["editorFontSize"] = newSize;
    };
    function handlePaste(event: ClipboardEvent) {
        const timeOut = setTimeout(() => {
            changeToWrap()
            clearTimeout(timeOut)
        }, 10)

        return;


    }
    function changeToWrap() {
        const selection = document.getSelection()
        let range;
        let start = 0;
        let end = 0;
        let startEl;
        let endEl;
        if (selection && selection!.rangeCount > 0) {
            range = selection.getRangeAt(0);
            start = range.startOffset
            end = range.endOffset
            startEl = range.startContainer
            endEl = range.endContainer
            //range.setEnd(range.endContainer,range.endOffset)
        }
        const element: HTMLDivElement = inputRef!.current!
        const text = element.innerHTML.replace("nowrap", "wrap");
        element.innerHTML = text
        if (range && selection) {
            selection.removeAllRanges()
            range.setStart(startEl!, start)
            range.setEnd(endEl!, end)
            selection.addRange(range)
            range.selectNodeContents(inputRef!.current!);
        }
        inputRef!.current!.focus()
    }

    function getSelectionIndexes(element: HTMLElement) {
        //const element = document.getElementById(elementId);
        if (!element) {
            return null; // Phần tử không tồn tại
        }

        let startIndex = 0,
            endIndex = 0;
        const sel = window.getSelection();

        if (sel.rangeCount > 0) {
            const range = sel.getRangeAt(0);
            const preCaretRange = range.cloneRange();
            preCaretRange.selectNodeContents(element);
            preCaretRange.setEnd(range.startContainer, range.startOffset);
            startIndex = preCaretRange.toString().length;
            endIndex = startIndex + range.toString().length;
        }

        return { start: startIndex, end: endIndex };
    }
    useEffect(() => {
        inputRef!.current!.innerHTML = htmlError || '';
        mergeAdjacentRedLinks(inputRef!.current!)
        if (errorRef && errorRef!.current) {
            errorRef!.current!.innerHTML = errorText || '';

        }

        inputRef!.current!.focus()
        const element: HTMLElement | null = document.getElementById("ltr0")
        if (element) {
            element.scrollIntoView({ behavior: 'auto' });
            element.focus();
        }
        setState(prev => ({
            ...prev,
            showSearch: false,
            searchQuery: '',
            highlightedMarks: [],
            currentIndex: -1,
        }))
        // if (inputRef!.current!.textContent == "") {
        //     if (placeholder) {
        //         inputRef!.current!.textContent = placeholder
        //     }
        // }
    }, [htmlError, triggerTime])
    useEffect(() => {
        if (errorRef && errorRef!.current)
            errorRef!.current!.innerHTML = errorText || '';

    }, [errorText])
    useEffect(() => {
        // Chỉ đồng bộ từ prop `message` khi caller thực sự truyền prop này.
        // Nếu không truyền (undefined), không được reset nội dung editor về rỗng.
        if (message === undefined) {
            return;
        }
        if (message) {
            inputRef!.current!.innerHTML = message.body;
            inputRef!.current!.focus()
            if (errorRef && errorRef!.current)
                errorRef!.current!.innerHTML = errorText || '';
            //console.log('message=', message)
        } else {
            if (inputRef && inputRef.current) {
                inputRef.current.innerHTML = '';
            }
            if (errorRef && errorRef.current) {
                errorRef.current.innerHTML = '';
            }
        }

    }, [message])
    useEffect(() => {
        if (currentContact) {
            if (currentContact.role == 2) {
                onMsgTypeChange && onMsgTypeChange(2)
                setState(prev => ({ ...prev, msgType: 2 }))
            } else if (currentContact.role == 1) {
                onMsgTypeChange && onMsgTypeChange(1)
                setState(prev => ({ ...prev, msgType: 1 }))
            }
        }
    }, [])
    let maxHeigthStr = ""
    if (maxHeight) {
        maxHeigthStr = `max-height:${maxHeight};`
    }
    function handleSearchConfirm(searchText: string) {
        // highlightInEditableDiv(inputRef!.current!, searchText)
        highlightMultipleKeywords(inputRef!.current!, searchText)
        // highlightPhraseAcrossElements(inputRef!.current!, searchText)
        console.log('search', searchText)
    }
    /**
     * Xóa tất cả các thẻ `<a style="color:red;">` nhưng giữ nguyên nội dung bên trong
     * @param divElement Phần tử div cần làm sạch
     */
    function removeAllRedLinks(divElement: HTMLElement): void {
        let links = divElement.querySelectorAll("a[style='color:red;']");

        links.forEach(link => {
            let parent = link.parentNode;
            while (link.firstChild) {
                parent?.insertBefore(link.firstChild, link); // Di chuyển nội dung ra ngoài
            }
            parent?.removeChild(link); // Xóa thẻ `<a>`
        });
    }
    /**
 * Loại bỏ tất cả các thẻ <mark> trong nội dung của div và gộp các thẻ <a style="color:red;" id="ltrX">
 * @param divElement Phần tử div cần làm sạch
 */
    function removeOldMarks(divElement: HTMLElement): void {
        // Xóa tất cả các thẻ <mark> nhưng giữ nguyên nội dung
        divElement.innerHTML = divElement.innerHTML.replace(/<\/?mark[^>]*>/g, "");

        // Gộp các thẻ <a style="color:red;" id="ltrX"> nếu chúng đứng sát nhau
        let container = document.createElement("div");
        container.innerHTML = divElement.innerHTML;

        let anchorNodes = Array.from(container.querySelectorAll("a[style='color:red;']")) as HTMLElement[];

        for (let i = 0; i < anchorNodes.length - 1; i++) {
            let currentA = anchorNodes[i];
            let nextA = anchorNodes[i + 1];

            // Kiểm tra nếu hai thẻ <a> có cùng style và đứng sát nhau
            if (currentA.nextSibling === nextA) {
                // Gộp nội dung của hai thẻ
                currentA.innerHTML += nextA.innerHTML;
                currentA.parentNode?.removeChild(nextA); // Xóa thẻ <a> sau khi gộp
                i--; // Giảm `i` để kiểm tra lại với thẻ mới gộp
            }
        }

        // Cập nhật nội dung đã chỉnh sửa vào div gốc
        divElement.innerHTML = container.innerHTML;
    }

    /**
     * Đánh dấu từ khóa trong div editable & cập nhật state với danh sách highlight
     * @param divElement Phần tử div có nội dung editable
     * @param searchQuery Từ khóa tìm kiếm
     */
    function highlightInEditableDiv(divElement: HTMLElement, searchQuery: string) {
        if (!searchQuery.trim()) return;

        removeOldMarks(divElement); // 🔴 Xóa highlight cũ trước khi tìm kiếm mới

        const searchNoAccent = removeVietnameseAccents(searchQuery.toLowerCase());
        const walker = document.createTreeWalker(divElement, NodeFilter.SHOW_TEXT, null);
        const textNodes: Text[] = [];
        let newHighlightedMarks: HTMLElement[] = [];

        // Lưu tất cả text node vào mảng (tránh thay đổi DOM khi duyệt)
        while (walker.nextNode()) {
            textNodes.push(walker.currentNode as Text);
        }

        textNodes.forEach((textNode) => {
            let textContentNoAccent = removeVietnameseAccents(textNode.nodeValue!.toLowerCase());
            let searchIndex = textContentNoAccent.indexOf(searchNoAccent);

            if (searchIndex !== -1) {
                let parent = textNode.parentNode!;
                let originalText = textNode.nodeValue!;

                let newContent = document.createDocumentFragment();
                let lastIndex = 0;

                while (searchIndex !== -1) {
                    // Tạo đoạn text trước từ khóa
                    if (searchIndex > lastIndex) {
                        newContent.appendChild(document.createTextNode(originalText.substring(lastIndex, searchIndex)));
                    }

                    // Tạo <mark> để highlight từ khóa
                    let mark = document.createElement("mark");
                    mark.style.backgroundColor = "yellow";
                    mark.style.cursor = "pointer";
                    mark.textContent = originalText.substring(searchIndex, searchIndex + searchQuery.length);
                    newContent.appendChild(mark);

                    newHighlightedMarks.push(mark); // Lưu vào danh sách highlight

                    // Cập nhật lại vị trí tìm kiếm
                    lastIndex = searchIndex + searchQuery.length;
                    searchIndex = textContentNoAccent.indexOf(searchNoAccent, lastIndex);
                }

                // Thêm đoạn text còn lại
                if (lastIndex < originalText.length) {
                    newContent.appendChild(document.createTextNode(originalText.substring(lastIndex)));
                }

                // Thay thế text node ban đầu bằng nội dung mới
                parent.replaceChild(newContent, textNode);
            }
        });

        // Cập nhật state với danh sách mới
        setState((prevState) => ({
            ...prevState,
            highlightedMarks: newHighlightedMarks,
            currentIndex: newHighlightedMarks.length > 0 ? 0 : -1,
        }));

        if (newHighlightedMarks.length > 0) {
            scrollToHighlight(0, newHighlightedMarks); // Cuộn đến kết quả đầu tiên nếu có
        }
    }

    /**
 * Đánh dấu nhiều từ khóa trong div editable & cập nhật danh sách highlight
 * @param divElement Phần tử div có nội dung editable
 * @param searchQuery Chuỗi chứa nhiều từ khóa (cách nhau bằng `|`)
 */
    function highlightMultipleKeywords(divElement: HTMLElement, searchQuery: string) {
        if (!searchQuery.trim()) return;

        removeOldMarks(divElement); // Xóa highlight cũ trước khi tìm kiếm mới

        // Tách từ khóa dựa trên ký tự `|`
        let keywords = searchQuery.split(",").map(k => k.trim()).filter(k => k.length > 0);
        if (keywords.length === 0) return;

        // Chuyển từ khóa thành không dấu
        let searchNoAccents = keywords.map(k => removeVietnameseAccents(k.toLowerCase()));

        // Lấy toàn bộ nội dung div (bao gồm HTML)
        let originalHTML = divElement.innerHTML;
        let originalTextNoAccents = removeVietnameseAccents(originalHTML.toLowerCase());

        let newHighlightedMarks: HTMLElement[] = [];

        // Duyệt qua từng từ trong nội dung HTML
        let highlightedHTML = "";
        let lastIndex = 0;

        let regex = new RegExp(`(${searchNoAccents.map(escapeRegExp).join("|")})`, "gi");

        // Tìm vị trí của từ khóa trong phiên bản không dấu
        let match;
        while ((match = regex.exec(originalTextNoAccents)) !== null) {
            let startIndex = match.index;
            let matchedWord = originalHTML.substring(startIndex, startIndex + match[0].length);

            // Thêm nội dung trước từ khóa
            highlightedHTML += originalHTML.substring(lastIndex, startIndex);

            // Highlight từ khóa
            highlightedHTML += `<mark style="background-color: yellow;">${matchedWord}</mark>`;

            lastIndex = startIndex + match[0].length;
        }

        // Thêm phần còn lại của nội dung
        highlightedHTML += originalHTML.substring(lastIndex);

        // Cập nhật lại nội dung HTML
        divElement.innerHTML = highlightedHTML;

        // Lưu danh sách tất cả các thẻ <mark>
        newHighlightedMarks = Array.from(divElement.querySelectorAll("mark"));

        // Cập nhật state với danh sách mới
        setState((prevState) => ({
            ...prevState,
            highlightedMarks: newHighlightedMarks,
            currentIndex: newHighlightedMarks.length > 0 ? 0 : -1,
        }));

        if (newHighlightedMarks.length > 0) {
            scrollToHighlight(0, newHighlightedMarks); // Cuộn đến kết quả đầu tiên nếu có
        }
    }
    /**
     * Escape ký tự đặc biệt trong regex (tránh lỗi khi tìm kiếm ký tự đặc biệt như `.` hoặc `(`)
     * @param text Chuỗi đầu vào
     * @returns Chuỗi đã được escape
     */
    function escapeRegExp(text: string): string {
        return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }

    /**
 * Cuộn đến highlight hiện tại
 * @param index Vị trí phần tử cần cuộn đến
 * @param marks Danh sách phần tử <mark> từ state
 */
    function scrollToHighlight(index: number, marks: HTMLElement[]) {
        if (marks.length === 0) return;
        if (index < 0 || index >= marks.length) return;

        const mark = marks[index];
        mark.scrollIntoView({ behavior: "smooth", block: "center" });

        // Làm nổi bật highlight hiện tại bằng border
        marks.forEach((el, i) => {
            el.style.outline = i === index ? "0.5px solid red" : "none";
        });

        // Cập nhật vị trí hiện tại trong state
        setState((prevState) => ({
            ...prevState,
            currentIndex: index,
        }));
    }

    /**
     * Chuyển đến highlight tiếp theo
     */
    function nextHighlight() {
        setState((prevState) => {
            const newIndex = (prevState.currentIndex + 1) % prevState.highlightedMarks.length;
            scrollToHighlight(newIndex, prevState.highlightedMarks);
            return { ...prevState, currentIndex: newIndex };
        });
    }

    /**
     * Chuyển đến highlight trước đó
     */
    function prevHighlight() {
        setState((prevState) => {
            const newIndex = (prevState.currentIndex - 1 + prevState.highlightedMarks.length) % prevState.highlightedMarks.length;
            scrollToHighlight(newIndex, prevState.highlightedMarks);
            return { ...prevState, currentIndex: newIndex };
        });
    }
    /**
  * Đánh dấu cụm từ trong `div contenteditable`, hỗ trợ tìm kiếm xuyên suốt nhiều thẻ HTML
  * @param divElement Phần tử div có nội dung editable
  * @param searchQuery Chuỗi cần tìm kiếm
  */
    function highlightPhraseAcrossElements(divElement: HTMLElement, searchQuery: string) {
        if (!searchQuery.trim()) return;

        removeOldMarks(divElement); // Xóa highlight cũ
        mergeAdjacentRedLinks(divElement); // Gộp các thẻ `<a>` bị tách rời

        let searchNoAccent = removeVietnameseAccents(searchQuery.toLowerCase());

        let walker = document.createTreeWalker(divElement, NodeFilter.SHOW_TEXT, null);
        let node: Node | null;
        let newHighlightedMarks: HTMLElement[] = [];

        while ((node = walker.nextNode())) {
            let textNode = node as Text;
            let textContent = textNode.nodeValue!;
            let textContentNoAccent = removeVietnameseAccents(textContent.toLowerCase());

            let searchIndex = textContentNoAccent.indexOf(searchNoAccent);
            if (searchIndex !== -1) {
                let parent = textNode.parentNode!;
                let beforeText = textContent.substring(0, searchIndex);
                let matchText = textContent.substring(searchIndex, searchIndex + searchQuery.length);
                let afterText = textContent.substring(searchIndex + searchQuery.length);

                // Tạo <mark> để highlight từ khóa
                let mark = document.createElement("mark");
                mark.style.backgroundColor = "yellow";
                mark.textContent = matchText;
                newHighlightedMarks.push(mark);

                let fragment = document.createDocumentFragment();
                if (beforeText) fragment.appendChild(document.createTextNode(beforeText));
                fragment.appendChild(mark);
                if (afterText) fragment.appendChild(document.createTextNode(afterText));

                parent.replaceChild(fragment, textNode);
            }
        }

        // Cập nhật danh sách highlight
        setState((prevState) => ({
            ...prevState,
            highlightedMarks: newHighlightedMarks,
            currentIndex: newHighlightedMarks.length > 0 ? 0 : -1,
        }));

        if (newHighlightedMarks.length > 0) {
            scrollToHighlight(0, newHighlightedMarks);
        }
    }


    store.dispatch(updateMienDaiCuoc({ mienDaiCuocId: state.mienDaiCuocId }))
    return (
        <>
            {showHeader &&
                <div className="common-container-row">

                    <LotSelect value={state.mienDaiCuocId} id="b"
                        onChange={(e) => {
                            setState(prev => ({ ...prev, mienDaiCuocId: e.target.value }))
                            store.dispatch(updateMienDaiCuoc({ mienDaiCuocId: e.target.value }))
                        }
                        }>
                        {isCuPhapMn() ? <>
                            <option value="3" selected={state.mienDaiCuocId == '3'}>Miền Nam</option>
                            <option value="2" selected={state.mienDaiCuocId == '2'}>Miền Trung</option>
                            <option value="1" selected={state.mienDaiCuocId == '1'}>Miền Bắc</option>

                        </> : <option value="1" selected={state.mienDaiCuocId == '1'}>Miền Bắc</option>
                        }
                    </LotSelect>
                    <LotSelect value={state.msgType}
                        id="msg-type"
                        onChange={(e) => {
                            setState((prev: any) => ({ ...prev, msgType: e.target.value }))
                            onMsgTypeChange && onMsgTypeChange(e.target.value)
                        }}
                    > {
                            ((currentContact.role & 1) != 0 || currentContact.role == 0) &&
                            <option value={"1"} selected={state.msgType == "1"}>Nhận của khách</option>
                        }
                        {(currentContact.role & 2) != 0 &&
                            <option value={"2"} selected={state.msgType == "2"}>Chuyển cho chủ</option>
                        }
                    </LotSelect>

                </div>
            }
            <div
                className="editable-div"
                style={
                    maxHeight ? `font-size:${fontSize}px;height:${maxHeight};text-wrap:wrap;${maxHeigthStr}`
                        : `font-size:${fontSize}px;height:35vh;text-wrap:wrap;`
                } contentEditable="true"
                onChange={handleChange}
                ref={inputRef}
                //dangerouslySetInnerHTML={{ __html: html }}
                onPaste={handlePaste}
                id="lot-edit-message"
                role="textbox"
                dir="auto"
                placeholder={placeholder}
            >

            </div>
            {/* <div className="font-size-range">
                <div>cỡ chữ</div>
                <div className="font-size-range input"> */}
            {
                state.showSearch &&
                <SearchBar onSearchConfirm={handleSearchConfirm}
                    onDownClick={() => nextHighlight()}
                    onUpClick={() => prevHighlight()}
                />
            }
            <div className=" font-setting-container">
                {!hidenFontSizeSetting &&
                    <div className="font-size-range">
                        <RangeSlider
                            value={fontSize}
                            min={16}
                            max={40}
                            label="Cỡ chữ"
                            onChange={handleSliderChange}

                        />
                    </div>
                }{showSaveButton &&

                    <Button round size="smaller" color="translucent"
                        onClick={() => {
                            if (onParseMessage) {
                                onParseMessage()

                            }
                        }}
                    >
                        <i className="fa-regular fa-floppy-disk fa-beat fa-xl"></i>
                    </Button>


                }
                {showSearchButton &&
                    <Button round size="tiny" color="translucent"
                        onClick={() => {
                            if (!state.showSearch) {
                                removeAllRedLinks(inputRef!.current!);
                            }
                            setState(prev => ({ ...prev, showSearch: !prev.showSearch }))
                        }
                        }
                    ><i className="icon icon-search"></i></Button>
                }
                <div />
            </div>



            {/* </div>
            </div> */}
            {!hidenErrorText &&
                <div style={`font-size:${fontSize}px;`} contentEditable={true}
                    className="read-only"
                    ref={errorRef}
                    onChange={() => {
                        errorRef!.current!.innerHTML = errorText;// cấm edit luôn
                    }}
                >

                </div>
            }
            {/* <div style={`font-size:${fontSize}px;`}>
                {htmlText}
            </div> */}

        </>
    )
}
export default memo(MessageEditor)